(function () {
  'use strict';

  angular
    .module('dashboard.interval')
    .directive('dashboardInterval', dashboardInterval);

  dashboardInterval.$inject = ['$timeout'];

  function dashboardInterval($timeout) {
    var directive = {
      bindToController: true,
      controller: 'dashboardIntervalCtrl',
      controllerAs: 'vm',
      template: require('../dashboard.interval/interval.html'),
      link: link,
      restrict: 'E',
      scope: {
        type: '@type',
        shortMode: '=shortMode',
      },
    };
    return directive;

    function link(scope, element, attrs, ctrl) {}
  }
})();
